import React from 'react';
import throttle from 'lodash.throttle';
import { Rectangle } from '@printu/geom';
import { getElementFrame } from 'app/utils/DOM';
import { call, noop } from 'app/utils/function';
import { onResize } from 'app/utils/Resize';
export const useResize = (
// ref: React.RefObject<DOMRefValue<HTMLDivElement>>,
getElement, handler, throttleDelay = 500) => {
    const [frame, setFrame] = React.useState(Rectangle.EMPTY.toObject());
    React.useEffect(() => {
        const logger = getLogger('Resize', 'debug');
        const element = getElement === null || getElement === void 0 ? void 0 : getElement();
        if (!element) {
            return noop;
        }
        logger('Attach');
        const updateContainerDimensions = () => {
            const bounds = getElementFrame(element).toObject();
            setFrame(bounds);
            call(handler, bounds);
            logger('Resized ', bounds);
        };
        const onWindowResize = throttle(() => {
            updateContainerDimensions();
        }, throttleDelay);
        window.addEventListener('resize', onWindowResize);
        const unobserveResize = onResize(element, onWindowResize);
        const dispose = () => {
            logger('Dispose');
            unobserveResize();
            window.removeEventListener('resize', onWindowResize);
        };
        return () => {
            dispose();
        };
    }, [throttleDelay, getElement, handler, setFrame]);
    return [frame];
};
